import * as React from "react";
const SvgMail = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", "xmlns:v": "https://vecta.io/nano", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.667 6L10 10l7.333-4M2.667 4h14.667v12H2.667V4z", stroke: "currentColor", strokeWidth: 1.75 }));
export default SvgMail;
